var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServerSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B4CCB9",
    d: "M14,60c0,1.104,0.896,2,2,2h32c1.104,0,2-0.896,2-2V38H14V60z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 26,
    fill: "#B4CCB9",
    width: 36,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    fill: "#B4CCB9",
    width: 36,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4CCB9",
    d: "M48,2H16c-1.104,0-2,0.896-2,2v8h36V4C50,2.896,49.104,2,48,2z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 26,
    width: 36,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 36,
    height: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,2H16c-1.104,0-2,0.896-2,2v8h36V4C50,2.896,49.104,2,48,2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M48,0H16c-2.211,0-4,1.789-4,4v56c0,2.211,1.789,4,4,4h32c2.211,0,4-1.789,4-4V4C52,1.789,50.211,0,48,0z  M50,60c0,1.104-0.896,2-2,2H16c-1.104,0-2-0.896-2-2V38h36V60z M50,36H14V26h36V36z M50,24H14V14h36V24z M50,12H14V4 c0-1.104,0.896-2,2-2h32c1.104,0,2,0.896,2,2V12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M43,6H21c-0.553,0-1,0.447-1,1s0.447,1,1,1h22c0.553,0,1-0.447,1-1S43.553,6,43,6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M21,20h22c0.553,0,1-0.447,1-1s-0.447-1-1-1H21c-0.553,0-1,0.447-1,1S20.447,20,21,20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M21,32h22c0.553,0,1-0.447,1-1s-0.447-1-1-1H21c-0.553,0-1,0.447-1,1S20.447,32,21,32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M32,58c1.657,0,3-1.344,3-3s-1.343-3-3-3s-3,1.344-3,3S30.343,58,32,58z M32,54c0.553,0,1,0.447,1,1 s-0.447,1-1,1s-1-0.447-1-1S31.447,54,32,54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M40,58c1.657,0,3-1.344,3-3s-1.343-3-3-3s-3,1.344-3,3S38.343,58,40,58z M40,54c0.553,0,1,0.447,1,1 s-0.447,1-1,1s-1-0.447-1-1S39.447,54,40,54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M24,58c1.657,0,3-1.344,3-3s-1.343-3-3-3s-3,1.344-3,3S22.343,58,24,58z M24,54c0.553,0,1,0.447,1,1 s-0.447,1-1,1s-1-0.447-1-1S23.447,54,24,54z"
  }))), /*#__PURE__*/React.createElement("circle", {
    fill: "#45AAB8",
    cx: 24,
    cy: 55,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F76D57",
    cx: 32,
    cy: 55,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9EBB2",
    cx: 40,
    cy: 55,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerSvgrepoCom);
export default __webpack_public_path__ + "static/media/server-svgrepo-com.158e4ef54d3d13e26646fdb2b926cc71.svg";
export { ForwardRef as ReactComponent };